import React, { useState } from 'react'
import { ToastContainer } from 'react-bootstrap';
import Toaster, { ToastProps } from './Toaster';


export const useToaster = (): {toastList: ToastProps[], addToast: (toastProps: ToastProps) => void} => {
    
    const [toastList, setAddToast] = useState<ToastProps[]>([]);

    const addToast = (toast:ToastProps) => {
        setAddToast(prev => {
            return [...prev, toast]
        });
    }
    return {toastList, addToast}
}

const ToasterList = ({list}: {list: ToastProps[]}) => {    

    return (
        <ToastContainer className="p-3" position='top-end' containerPosition='fixed'>
            {list.map((toast, idx) => {
                return <Toaster key={idx} onCloseEvent={toast.onCloseEvent} idx={toast.idx} theme={toast.theme} title={toast.title} body={toast.body} autohide={toast.autohide} />
            })}
        </ToastContainer>
    )
}

export default ToasterList